import type { OrganizationAllowedBobcatOfferGroupDTO } from '@/api/trafikportalen';
import type { CollectionTypeDTO } from '@/api/trafikportalen/models/collectionTypeDTO';

export const offerGroupsSharedByOrganizations = (
  allowedByOrganization: OrganizationAllowedBobcatOfferGroupDTO[][],
  collectionType: CollectionTypeDTO,
): OrganizationAllowedBobcatOfferGroupDTO[] => {
  if (allowedByOrganization.length === 0) return [];

  const relevant = allowedByOrganization.map((groups) => {
    const byId = new Map<string, OrganizationAllowedBobcatOfferGroupDTO>();
    for (const group of groups) {
      if (group.collection_type !== collectionType) continue;
      if (group.sales_channel !== 'school') continue;
      if (!byId.has(group.id)) byId.set(group.id, group);
    }
    return byId;
  });

  const [first, ...rest] = relevant;
  if (!first) return [];

  return [...first.values()].filter((group) =>
    rest.every((groups) => groups.has(group.id)),
  );
};
